module.exports = __webpack_public_path__ + "static/media/nutrionist.18a3d7dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/nutrionist.svg
// module id = 236
// module chunks = 1